import axios from '../utils/axios';
import config from '../utils/config';

const ANALYSIS_REQUEST = config.get('analysis_api', 'analysis_request_url');
const CAMPAIGN_DETAILS_REQUEST = config.get('analysis_api', 'campaign_details_url');
const DELETE_CAMPAIGN_URL = config.get('analysis_api','delete_campaign');
const KPI_DETAILS_REQUEST = config.get('analysis_api', 'kpi_details_url');
const KPI_INSIGHT_REQUEST = config.get('analysis_api', 'kpi_insight_url');
const NOTIFY_ANALYSIS = config.get('analysis_api', 'notify_analysis');


async function analysisRequest(accessToken, username, data) {
    try {
      const analysisReqResponse = await axios({
        method: 'post',
        responseType: 'json',
        url: ANALYSIS_REQUEST,
        data: data,
        headers: {
          'x-access-token': accessToken,
          'x-user': username,
        }
      });
      return analysisReqResponse;
    } catch (error) {
      throw error.response;
    }
}

async function getCampaignDetails(accessToken, username, campaignId) {
    try {
        const campaignDetailsResponse = await axios({
          method: 'get',
          responseType: 'json',
          url: config.formUrl(CAMPAIGN_DETAILS_REQUEST, campaignId),
          headers: {
            'x-access-token': accessToken,
            'x-user': username,
          },
        });
        return campaignDetailsResponse;
      } catch (error) {
        throw error.response;
      }
}

async function deleteCampaign(accessToken, username, campaignId, payload) {
  try {
    const deleteResponse = await axios({
      method: 'post',
      responseType: 'json',
      url: config.formUrl(DELETE_CAMPAIGN_URL, campaignId),
      data: payload,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return deleteResponse;
  } catch (error) {
    throw error.response;
  }
}

async function getKpiDetails(accessToken, username, campaignId) {
  try {
      const kpiDetailsResponse = await axios({
        method: 'get',
        responseType: 'json',
        url: config.formUrl(KPI_DETAILS_REQUEST, campaignId),
        headers: {
          'x-access-token': accessToken,
          'x-user': username,
        },
      });
      return kpiDetailsResponse;
    } catch (error) {
      throw error.response;
    }
}

async function getKpiInsight(accessToken, username, analysisId) {
  try {
      const kpiInsightResponse = await axios({
        method: 'get',
        responseType: 'json',
        url: config.formUrl(KPI_INSIGHT_REQUEST, analysisId),
        headers: {
          'x-access-token': accessToken,
          'x-user': username,
        },
      });
      return kpiInsightResponse;
    } catch (error) {
      throw error.response;
    }
}


async function notifyAnalysis(accessToken, username, campaignId) {
  try {
      const campaignDetailsResponse = await axios({
        method: 'get',
        responseType: 'json',
        url: config.formUrl(NOTIFY_ANALYSIS, campaignId),
        headers: {
          'x-access-token': accessToken,
          'x-user': username,
        },
      });
      return campaignDetailsResponse;
    } catch (error) {
      throw error.response;
    }
}
export {
    analysisRequest,
    getCampaignDetails,
    deleteCampaign,
    getKpiDetails,
    getKpiInsight,
    notifyAnalysis
} 